const ANIMAL_SET_ACHIEVEMENTS = {
  legendaryBestiary: {
    type: 'pet',
    species: [
      'Dragon',
      'FlyingPig',
      'Gryphon',
      'SeaSerpent',
      'Unicorn',
    ],
    achievementKey: 'legendaryBestiary',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  birdsOfAFeather: {
    type: 'pet',
    species: [
      'FlyingPig',
      'Owl',
      'Parrot',
      'Pterodactyl',
      'Gryphon',
      'Falcon',
      'Rooster',
      'Peacock',
    ],
    achievementKey: 'birdsOfAFeather',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  bonelessBoss: {
    type: 'pet',
    species: [
      'Beetle',
      'Butterfly',
      'Cuttlefish',
      'Nudibranch',
      'Octopus',
      'Snail',
      'Spider',
    ],
    achievementKey: 'bonelessBoss',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  cats: {
    type: 'pet',
    species: [
      'Cheetah',
      'LionCub',
      'Sabretooth',
      'TigerCub',
    ],
    achievementKey: 'cats',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  dinosaurDynasty: {
    type: 'pet',
    species: [
      'Falcon',
      'Owl',
      'Parrot',
      'Peacock',
      'Penguin',
      'Rooster',
      'Pterodactyl',
      'TRex',
      'Triceratops',
      'Velociraptor',
    ],
    achievementKey: 'dinosaurDynasty',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  domesticated: {
    type: 'pet',
    species: [
      'Ferret',
      'GuineaPig',
      'Rooster',
      'FlyingPig',
      'Rat',
      'Bunny',
      'Horse',
      'Cow',
    ],
    achievementKey: 'domesticated',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  duneBuddy: {
    type: 'pet',
    species: [
      'Armadillo',
      'Cactus',
      'Fox',
      'Frog',
      'Snake',
      'Spider',
    ],
    achievementKey: 'duneBuddy',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  plantParent: {
    type: 'pet',
    species: [
      'Cactus',
      'Treeling',
    ],
    achievementKey: 'plantParent',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  polarPro: {
    type: 'pet',
    species: [
      'BearCub',
      'Fox',
      'Penguin',
      'Whale',
      'Wolf',
    ],
    achievementKey: 'polarPro',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  reptacularRumble: {
    type: 'pet',
    species: [
      'Alligator',
      'Pterodactyl',
      'Snake',
      'Triceratops',
      'TRex',
      'Turtle',
      'Velociraptor',
    ],
    achievementKey: 'reptacularRumble',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  rodentRuler: {
    type: 'pet',
    species: [
      'Rat',
      'GuineaPig',
      'Squirrel',
    ],
    achievementKey: 'rodentRuler',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  roughRider: {
    type: 'petMount',
    species: [
      'Cactus',
      'Hedgehog',
      'Rock',
    ],
    achievementKey: 'roughRider',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  woodlandWizard: {
    type: 'pet',
    species: [
      'Badger',
      'BearCub',
      'Deer',
      'Fox',
      'Frog',
      'Hedgehog',
      'Owl',
      'Snail',
      'Squirrel',
      'Treeling',
    ],
    achievementKey: 'woodlandWizard',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
  zodiacZookeeper: {
    type: 'pet',
    species: [
      'Rat',
      'Cow',
      'Bunny',
      'Snake',
      'Horse',
      'Sheep',
      'Monkey',
      'Rooster',
      'Wolf',
      'TigerCub',
      'FlyingPig',
      'Dragon',
    ],
    achievementKey: 'zodiacZookeeper',
    notificationType: 'ACHIEVEMENT_ANIMAL_SET',
  },
};

export default ANIMAL_SET_ACHIEVEMENTS;
